import { ExclamationCircleIcon } from '@heroicons/react/24/solid';

import {
  UserIcon,
  KeyIcon,
  EyeIcon,
  EyeSlashIcon
} from '@heroicons/react/24/solid';

import { useState } from 'react';

export default function Input({
  type = 'text',
  placeholder,
  name,
  value,
  onChange,
  error = false,
  errorMessage = '',
  icon = 'user'
}) {
  const [showPassword, setShowPassword] = useState(false);
  const IconComponent = icon === 'key' ? KeyIcon : UserIcon;

  return (
    <div className="w-full max-w-xl">
      <div
        className={`flex items-center px-2 bg-white w-full h-12 border ${error ? 'border-red-500' : 'border-gray-300'}`}
      >
        <IconComponent
          className={`w-7 h-7 ${error ? 'text-red-500' : 'text-gray-300'}`}
        />
        <div className="bg-gray-200 mx-2 w-px h-8" />
        <input
          type={
            type === 'password' ? (showPassword ? 'text' : 'password') : type
          }
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          className={`flex-1 bg-transparent border-none outline-none text-base ${error ? 'text-red-500' : 'text-gray-900'} placeholder-gray-400`}
        />
        {type === 'password' && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="p-1 focus:outline-none text-gray-400 hover:text-gray-600"
          >
            {showPassword ? (
              <EyeSlashIcon className="w-5 h-5" />
            ) : (
              <EyeIcon className="w-5 h-5" />
            )}
          </button>
        )}
      </div>
      {error && (
        <div className="flex items-center mt-1 px-1 font-bold text-red-600 text-sm">
          <ExclamationCircleIcon className="mr-1 w-4 h-4" />
          {errorMessage}
        </div>
      )}
    </div>
  );
}
